import { Portal } from "@mui/material";
import { ReactNode, useEffect, useState } from "react";

interface Props {
  children: ReactNode;
}

const PortaledBottomActionBar = ({ children }: Props) => {
  const [container, setContainer] = useState<HTMLElement | null>(null);

  useEffect(() => {
    // Function to find the container element
    const findContainer = () => {
      const element = document.getElementById("bottom-action-bar");
      if (element) {
        setContainer(element);
        return true;
      }
      return false;
    };

    // Try to find the container immediately
    if (!findContainer()) {
      // If not found, set up a MutationObserver to watch for DOM changes
      const observer = new MutationObserver(() => {
        if (findContainer()) {
          observer.disconnect();
        }
      });

      observer.observe(document.body, {
        childList: true,
        subtree: true,
      });

      // Cleanup observer on unmount
      return () => observer.disconnect();
    }
  }, []);

  // Don't render anything until we have a container
  if (!container) {
    return null;
  }

  return <Portal container={container}>{children}</Portal>;
};

export default PortaledBottomActionBar;
